import styled from "styled-components";
import { colors } from "../../../../styles/variables";

export const StyledLabelWrapper = styled.div`
  color: ${colors.gray600};
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    margin-left: 7px;
  }
`;

export const StyledContent = styled.div<{ isNested: boolean }>`
  background-color: ${colors.gray100};
  border-radius: 4px;
  font-size: 13px;
  ${({ isNested }) =>
    isNested
      ? `
      padding-top: 6px;
  `
      : `
    padding: 8px;
    margin-top: 4px;
  `}
`;
